export default {
  title: 'Betaalgateway',
  description:
    'Uw eigen betaalgateways voor online bestellingen. Het volledige bestelbedrag wordt uitbetaald op uw gatewayaccount; u verrekent zelf met uw restaurants.',
  toasts: {
    load_error: 'Laden van de gateway-instellingen mislukt',
  },
  not_enabled: {
    title: 'Spreedly is nog niet geactiveerd voor uw account',
    description:
      'Lokale betaalgateways worden geactiveerd door FoodAmigos. Neem contact op met uw FoodAmigos-contactpersoon om te starten.',
  },
  processor_mode: {
    title: 'Wie verwerkt de betalingen?',
    description:
      'Dit wordt eenmalig ingesteld voor al je restaurants. Je kunt dit later wijzigen in Partnerinstellingen zolang geen enkel restaurant live is.',
    save: 'Opslaan',
    options: {
      platform: {
        title: 'FoodAmigos verwerkt betalingen',
        badge: 'Aanbevolen',
        description:
          'Wij regelen de betaalrekening, verificatie en uitbetalingen. Elk restaurant voegt zijn bedrijfsgegevens toe en doorloopt een korte controle bij Adyen.',
        methods: 'Geaccepteerd: {{methods}}',
      },
      provider: {
        title: 'Ik gebruik mijn eigen aanbieder',
        description:
          'Verbind een betaalprovider die je al gebruikt. Uitbetalingen, kosten en verificatie blijven bij hen.',
      },
    },
    payment_methods: {
      card: 'Kaart',
      apple_pay: 'Apple Pay',
      google_pay: 'Google Pay',
      pay_by_bank: 'Betalen via bank',
      giropay: 'giropay',
      sepa_debit: 'SEPA',
    },
    locked: {
      platform: 'FoodAmigos verwerkt betalingen voor al je restaurants.',
      provider: 'Je restaurants ontvangen betalingen via je eigen providers.',
    },
    confirm_choice: {
      title: 'Betalingen instellen op “{{mode}}”?',
      description:
        'Dit geldt voor elk restaurant dat je runt. Je kunt dit later wijzigen in Partnerinstellingen, maar alleen zolang geen enkel restaurant live is.',
      confirm: 'Opslaan en doorgaan',
    },
    switch: {
      link: 'Wijzig hoe betalingen worden verwerkt',
      confirm: {
        confirm: 'Wisselen',
        provider: {
          title: 'Overschakelen naar je eigen provider?',
          description: 'Restaurants die FoodAmigos-betalingen gebruiken, gaan terug naar Niet ingesteld.',
        },
        platform: {
          title: 'Overschakelen naar FoodAmigos-betalingen?',
          description: 'Restaurants die hun eigen providers gebruiken, gaan terug naar Niet ingesteld.',
        },
      },
      unavailable: {
        title: 'FoodAmigos-betalingen zijn nog niet beschikbaar',
        description: 'FoodAmigos-betalingen zijn in jouw land nog niet beschikbaar.',
        confirm: 'OK',
      },
      blocked: {
        title: 'Neem contact op met FoodAmigos om dit te wijzigen',
        description_one:
          '{{count}} restaurant verwerkt live betalingen. Overstappen betekent dat het opnieuw moet aansluiten bij de nieuwe provider. Ons team plant dit samen met u.',
        description_other:
          '{{count}} restaurants ontvangen live betalingen. Wisselen zou betekenen dat zij opnieuw onboarden bij de nieuwe provider. Ons team plant dit samen met jou.',
        confirm: 'E-mail FoodAmigos',
        subject_one: 'Betalingsverwerking wijzigen ({{count}} live restaurant)',
        subject_other: 'Wijzig hoe betalingen worden verwerkt ({{count}} live restaurants)',
      },
    },
    toasts: {
      load_error: 'Laden van de betaalconfiguratie mislukt',
      save_error: 'Opslaan van de betaalconfiguratie mislukt',
      chosen: 'Betaalverwerking opgeslagen',
      switched: 'Betaalverwerking gewisseld',
    },
  },
  gateways: {
    title: 'Verbonden providers',
    empty: 'Verbind de betaalprovider die je al gebruikt. Je restaurants worden hieronder aangesloten.',
    connect_another: 'Provider verbinden',
    support_hint:
      'Zodra een restaurant live betalingen ontvangt, plannen we een providerwijziging samen met jou — mail naar {{email}}.',
    kinds: {
      stripe_connect: 'Stripe Connect',
      spreedly: 'Betaalgateway',
      platform_adyen: 'FoodAmigos-betalingen',
    },
    statuses: {
      connected: 'Verbonden',
      disconnected: 'Niet verbonden',
      needs_attention: 'Aandacht vereist',
    },
    issue: {
      connect_not_enabled: {
        title: 'Stripe Connect is niet ingeschakeld voor het account van {{name}}',
        description:
          'Stripe kan geen accounts voor je restaurants aanmaken zolang Connect niet is ingeschakeld. Schakel het in via je Stripe Dashboard en controleer het hier opnieuw.',
      },
      account_restricted: {
        title: 'Stripe houdt nieuwe accounts onder {{name}} tegen',
        description:
          'Stripe heeft je account tijdelijk beperkt bij het aanmaken van gekoppelde accounts. Log in op je Stripe Dashboard, bevestig dat je deze accounts wilde aanmaken en controleer het hier opnieuw.',
      },
      loss_liability_unaccepted: {
        title: 'Stripe vereist dat {{name}} eerst de verliesaansprakelijkheid accepteert',
        description:
          'Je Stripe-platform heeft de verantwoordelijkheid voor negatieve saldi op de accounts van je restaurants nog niet geaccepteerd, dus Stripe maakt ze niet aan. Open in je Stripe Dashboard Settings → Connect → Platform profile en rond de bevestiging van verliesaansprakelijkheid af. Controleer het daarna hier opnieuw. Je kunt de opmerking van Stripe over Accounts v2 hieronder negeren.',
      },
      account_creation_refused: {
        title: 'Stripe weigerde een restaurantaccount aan te maken onder {{name}}',
        description: 'Bekijk het onderstaande bericht in je Stripe Dashboard en controleer het hier opnieuw.',
      },
      key_invalid: {
        title: 'Stripe accepteert de sleutel die je voor {{name}} hebt gekoppeld niet meer',
        description:
          'De sleutel is vernieuwd, ingetrokken of verlopen. Maak een nieuwe sleutel aan in je Stripe Dashboard en vervang hem hier.',
      },
      key_access_limited: {
        title: 'Stripe heeft de sleutel die je voor {{name}} hebt gekoppeld beperkt',
        description:
          'Met een beperkte sleutel kunnen geen overboekingen of uitbetalingen voor je restaurants worden aangemaakt. Open in je Stripe Dashboard Developers → API keys en herstel de volledige toegang van de sleutel. Controleer het daarna hier opnieuw — of vernieuw de sleutel en vervang hem hier.',
      },
      provider_said: 'Wat Stripe zei: „{{message}}”',
      hint: 'Zolang dit niet is opgelost, kunnen restaurants die aan deze aanbieder zijn gekoppeld geen online betalingen accepteren.',
      open_stripe: 'Stripe Dashboard openen',
      check_again: 'Opnieuw controleren',
      replace_key: 'Sleutel vervangen',
      cleared: 'Stripe accepteert je restaurants weer',
      still_blocked: 'Stripe weigert nog steeds — zie hierboven wat het zei',
    },
    refused: {
      provider_said: 'Wat {{name}} zei: “{{message}}”',
      reference: 'Referentie:',
      contact_support: 'E-mail support',
      support_subject: 'Betaalprovider verbinding geweigerd: {{name}} (ref {{reference}})',
      account_in_test_mode: {
        action: 'Schakel Testmodus uit in Authorize.Net, onder {{path}}, en probeer het opnieuw.',
        open: 'Authorize.Net openen',
      },
      processor_not_configured: {
        action:
          'Neem contact op met uw payment provider, het bedrijf waarmee u uw Authorize.Net-account heeft geopend, en vraag hen om de koppeling met de betaalverwerker af te ronden. Nieuwe sleutels veranderen hier niets aan. Probeer het daarna opnieuw.',
        action_card_connect:
          'Vraag CardConnect-support om card-not-present-autorisaties (e-commerce) voor dit merchant-ID in te schakelen. Nieuwe API-inloggegevens veranderen hier niets aan. Probeer het daarna opnieuw.',
      },
    },
    table: {
      primary_tag: 'Standaard',
      live_count_one: '{{count}} nemen betalingen aan',
      live_count_other: '{{count}} nemen betalingen aan',
      attention_count_one: '{{count}} vereist aandacht',
      attention_count_other: '{{count}} vereisen aandacht',
      columns: {
        connection: 'Provider',
        status: 'Status',
        restaurants: 'Restaurants',
        methods: 'Lokale methoden',
      },
      methods_count: '{{enabled}} van {{capable}} actief',
    },
    picker: {
      recommended: 'Aanbevolen',
      connect: 'Verbinden',
      stripe_connect: {
        title: 'Stripe Connect',
        description:
          'Gebruik je eigen Stripe-account. Elk restaurant doorloopt Stripe’s eigen onboarding; uitbetalingen en kosten blijven bij Stripe.',
        already_connected: 'Al verbonden. Gebruik Inloggegevens bewerken in de lijst om de sleutel te vervangen.',
        already_connected_short: 'Al verbonden.',
      },
      stripe_direct: {
        title: 'Stripe (direct)',
        description: 'Belast elk restaurant via één Stripe-account van jou.',
        unavailable: 'Nog niet beschikbaar in uw regio.',
      },
      paypal: {
        direct: 'Bied PayPal aan vanuit uw eigen zakelijke PayPal-account.',
        braintree: 'Accepteer kaarten, PayPal en Venmo via uw Braintree-account.',
      },
      other: {
        title: 'Andere providers',
        search: 'Providers zoeken',
        loading: 'Providers laden…',
        no_match: 'Geen provider genaamd “{{query}}”.',
        none_available: 'Er zijn nog geen andere providers beschikbaar in uw regio.',
        load_error: 'De lijst met providers kon niet worden geladen.',
        retry: 'Opnieuw proberen',
        pinned_match: 'Die provider is hierboven vastgezet.',
      },
      not_listed: {
        action: 'Mijn provider staat er niet bij',
        subject: 'Aanvraag betaalprovider: {{query}}',
      },
      use_foodamigos: {
        no_account: 'Ik heb bij geen van deze een account',
        switch: 'Overschakelen naar FoodAmigos-betalingen',
      },
    },
    orchestrated: {
      title: '{{name}} verbinden',
      replace_title: 'Vervang de inloggegevens voor {{name}}',
      intro:
        'Voer de inloggegevens van uw {{name}}-account in. We controleren ze bij {{name}} voordat er iets wordt opgeslagen.',
      auth_mode: 'Hoe u zich aanmeldt bij deze provider',
      checking: 'Controleren bij {{name}}…',
      paypal_direct: {
        intro:
          'Plak de Client-ID en Secret van de PayPal REST-app waarmee uw restaurants PayPal moeten accepteren. We controleren deze bij PayPal voordat er iets wordt opgeslagen.',
        client_id: 'Client-ID',
        secret: 'Secret',
        hint: 'PayPal Developer Dashboard → Apps & Credentials, op het Live-tabblad. Gebruik een REST-app van uw zakelijke account.',
        hint_sandbox:
          'PayPal Developer Dashboard → Apps & Credentials, op het tabblad Sandbox: deze omgeving accepteert alleen sandbox-apps.',
      },
      braintree: {
        intro:
          'Voer de API-sleutels van uw Braintree-account in. PayPal en Venmo werken zodra ze zijn gekoppeld in uw Braintree Control Panel — u schakelt ze daarna per verbinding in.',
      },
      authorize_net: {
        intro:
          'Voer de API Login ID en Transaction Key van uw Authorize.Net-account in. We controleren ze met een kleine testautorisatie: uw Authorize.Net-transactielog toont dit als een geweigerde $1,00, en er wordt geen geld verplaatst. Het account moet in Live-modus staan, want in Testmodus weigert Authorize.Net elke echte betaling.',
        hint: 'U vindt beide in de Authorize.Net Merchant Interface, onder {{path}}.',
      },
      card_connect: {
        intro:
          'Voer het merchant-ID, de gebruikersnaam en het wachtwoord in van uw live CardConnect-account (CardPointe). We controleren ze met een autorisatie van 1,00 die we meteen annuleren: in uw CardPointe-transactielog verschijnt dit als een geweigerde of geannuleerde 1,00 en er wordt geen geld overgemaakt.',
      },
      stripe_direct: {
        intro:
          'Plak de geheime sleutel of een beperkte sleutel van het Stripe-account waarmee elk restaurant moet afrekenen. De webhook die Stripe nodig heeft, stellen wij voor je in.',
        secret_key: 'Stripe-geheime of beperkte sleutel',
        hint: 'Stripe → Developers → API keys. Begint met sk_ (geheim) of rk_ (beperkt). Een beperkte sleutel heeft schrijftoegang nodig tot Charges and Refunds, Customers, PaymentIntents, PaymentMethods, SetupIntents, Tokens en Webhook Endpoints. Een publiceerbare sleutel is niet nodig.',
        prefix_error: 'Geheime Stripe-sleutels beginnen met sk_, beperkte sleutels met rk_.',
      },
      connected: {
        title: '{{name}} is verbonden.',
        description:
          'We gebruiken deze inloggegevens voor al uw restaurants. Elk restaurant voegt nog steeds zijn bedrijfsgegevens toe.',
      },
      errors: {
        generic: 'We konden {{name}} niet verbinden',
      },
    },
    stripe: {
      title: 'Stripe Connect verbinden',
      rotate_title: 'Vervang uw Stripe Connect-sleutel',
      rotate_intro:
        'Plak een nieuwe geheime sleutel en publiceerbare sleutel van hetzelfde Stripe-account. Je restaurants blijven verbonden.',
      intro:
        'Plak de geheime sleutel en de publiceerbare sleutel van je Stripe-account. Beide staan onder Developers → API keys.',
      verify_and_connect: 'Verifiëren en verbinden',
      checking: 'Controleren bij Stripe…',
      secret_key: {
        label: 'Geheime sleutel',
        hint: 'Stripe → Developers → API keys. Begint met sk_.',
        prefix_error: 'Geheime sleutels beginnen met sk_. Dit lijkt een ander soort sleutel te zijn.',
      },
      restricted_key: {
        label: 'Restricted API-key',
        hint: 'Stripe → Developers → API keys → Create restricted key. Begint met rk_. Stel hem in zoals hierboven beschreven.',
        prefix_error: 'Restricted keys beginnen met rk_. Dit lijkt een ander soort key te zijn.',
      },
      use_restricted_key: 'Gebruik in plaats daarvan een beperkte sleutel',
      use_secret_key: 'Gebruik in plaats daarvan de geheime sleutel',
      publishable_key: {
        label: 'Publishable key',
        hint: 'Op dezelfde Stripe-pagina. Begint met pk_. Je webshops hebben deze nodig om kaarten te accepteren.',
        prefix_error: 'Publishable keys beginnen met pk_.',
        mode_mismatch:
          'Eén sleutel is een live-sleutel en de andere een testsleutel. Beide moeten uit dezelfde Stripe-modus komen.',
      },
      name: {
        label: 'Naam voor deze verbinding',
        hint: 'Optioneel. Wordt getoond waar deze provider vermeld staat.',
        placeholder: 'Stripe Connect',
      },
      permissions: {
        title: 'Hoe je deze key aanmaakt',
        start_blank:
          'Wanneer Stripe vraagt hoe je de sleutel gaat gebruiken, kies dan “{{option}}”. Alle rechten staan dan op {{none}}.',
        intro:
          'Zet vervolgens de schakelaar bij elk van deze sectierijen. Hiermee stel je alle rechten in die sectie in, dus je hoeft ze niet één voor één langs te gaan.',
        rows_checked: 'Wij controleren: {{rows}}',
        secret_key_hint: 'Laat alle andere secties op {{none}} staan. Een geheime sleutel heeft hier niets van nodig.',
        open_stripe: 'Open je Stripe API-sleutels',
      },
      login_setting: {
        title: 'Schakel de Stripe-login voor je restaurants uit',
        description:
          'Open in je Stripe Dashboard Instellingen → Connect → Uitbetalingen → Externe rekeningen en schakel “{{setting}}” uit. Zolang deze optie aanstaat, laat Stripe elk restaurant tijdens de onboarding een Stripe-login met een telefoonnummer aanmaken en vraagt Stripe bij elk later bezoek om een sms-code, waardoor wie die telefoon niet heeft niet verder kan.',
        bank_details: 'Er gaat niets verloren: restaurants vullen hun bankgegevens in ons eigen formulier in.',
        open_stripe: 'Open deze Stripe-instelling',
      },
      errors: {
        generic: 'Stripe kon niet worden bereikt',
      },
    },
    default_choice: {
      label: 'Gebruiken als standaard voor restaurants',
      hint: 'Nieuwe restaurants en restaurants zonder provider worden er automatisch aan gekoppeld. Laat dit uitgevinkt om zelf per restaurant een provider te kiezen.',
    },
    manage: {
      payment_methods: 'Betaalmethoden',
      edit_credentials: 'Inloggegevens bewerken',
      edit_credentials_unavailable: 'Gegevens bewerken (deze provider wordt momenteel niet aangeboden)',
      set_primary: 'Instellen als standaard voor nieuwe restaurants',
      clear_primary: 'Niet meer als standaard gebruiken voor nieuwe restaurants',
      rename: {
        action: 'Verbinding hernoemen',
        title: 'Deze verbinding hernoemen',
        confirm: 'Opslaan',
      },
      disconnect: {
        action: 'Verbinding verbreken',
        title: 'Verbinding met {{name}} verbreken?',
        confirm: 'Verbinding verbreken',
        warning_one: '{{count}} restaurant is eraan gekoppeld en wordt teruggezet naar Niet ingesteld.',
        warning_other: '{{count}} restaurants zijn eraan gekoppeld en worden teruggezet naar Niet ingesteld.',
        live: {
          title_one: 'Online betalingen worden gepauzeerd voor {{count}} live restaurant',
          title_other: 'Online betalingen worden gepauzeerd voor {{count}} live restaurants',
          description:
            'Zodra u de koppeling verbreekt, kunnen hun klanten niet meer online betalen. Elk restaurant gaat terug naar Niet ingesteld totdat u het aan een andere provider koppelt.',
          refunds:
            'Bestellingen die al via deze provider zijn betaald, kunnen niet meer worden terugbetaald via FoodAmigos.',
          pause_one: 'Onlinebetalingen voor dit restaurant pauzeren',
          pause_other: 'Onlinebetalingen voor deze {{count}} restaurants pauzeren',
          confirm: 'Koppeling verbreken en betalingen pauzeren',
        },
      },
      remove: {
        action: 'Uit lijst verwijderen',
        title: '{{name}} verwijderen?',
        description:
          'Deze is al losgekoppeld en wordt door geen enkel restaurant gebruikt. Hij wordt niet meer in deze lijst getoond.',
        confirm: 'Verwijderen',
      },
    },
    payment_methods: {
      title: 'Betaalmethoden voor {{name}}',
      description:
        'Kies de lokale methoden die uw restaurants via deze provider aanbieden. Elke methode wordt alleen getoond als de valuta van het restaurant overeenkomt.',
      save: 'Opslaan',
      publishable_key: {
        label: 'Stripe publiceerbare sleutel',
        hint: 'Stripe heeft dit nodig om het betaalformulier te tonen. U vindt het in uw Stripe Dashboard onder Developers → API keys.',
        invalid: 'Een publiceerbare sleutel begint hier met {{prefix}}.',
        clear_to_save:
          'Dit hoort bij de andere modus van Stripe. Wis het om op te slaan met alle lokale methoden uitgeschakeld.',
      },
      on_other_connection: 'al ingeschakeld voor {{connection}}',
      other_currency: 'niet beschikbaar in {{currency}}',
      delivery_only: '{{name}} (alleen bezorgbestellingen — het adres van de klant is nodig)',
      invite_only:
        '{{name}} (Stripe biedt dit alleen op uitnodiging aan — vraag eerst toegang aan in je Stripe-dashboard, anders weigert Stripe elke betaling)',
      also_enable: {
        stripe:
          'Schakel dezelfde methoden in uw Stripe Dashboard in onder Settings → Payment methods, anders weigert Stripe ze.',
        provider: 'Uw contract met deze provider moet de methoden bevatten die u hier inschakelt.',
        braintree:
          'Koppel PayPal en Venmo eerst in uw Braintree Control Panel onder Settings → Processing, anders weigert Braintree ze. Venmo is voor Amerikaanse restaurants die in dollars rekenen.',
        paypal_direct:
          'PayPal-betalingen worden gestort op dit zakelijke PayPal-account. Verbind Braintree voor Venmo.',
      },
    },
    actions: {
      cancel: 'Annuleren',
    },
    toasts: {
      load_error: 'Kon je verbonden providers niet laden',
      credentials_replaced: 'Inloggegevens vervangen',
      save_error: 'Opslaan mislukt',
      connected: 'Stripe Connect is verbonden',
      renamed: 'Verbinding hernoemd',
      primary_set: 'Standaardprovider bijgewerkt',
      primary_cleared:
        'Standaardprovider verwijderd. Nieuwe restaurants worden niet aan een provider gekoppeld totdat u er een kiest.',
      disconnected: 'Provider losgekoppeld',
      removed: 'Provider verwijderd',
      payment_methods_saved: 'Betaalmethoden opgeslagen',
    },
  },
  restaurants: {
    title: 'Restaurants',
    description: 'De status van elk restaurant voor het accepteren van online betalingen.',
    search: 'Restaurants zoeken',
    filters: {
      all: 'Alle ({{count}})',
      needs_attention: 'Vereist aandacht ({{count}})',
    },
    empty: 'Nog geen restaurants.',
    empty_attention: 'Niets vereist uw aandacht.',
    columns: {
      restaurant: 'Restaurant',
      provider: 'Provider',
      status: 'Status',
      action: 'Actie',
    },
    no_provider: '—',
    foodamigos_payments: 'FoodAmigos-betalingen',
    groups: {
      not_set_up: 'Niet ingesteld',
      business_details_missing: 'Bedrijfsgegevens ontbreken',
      hosted_not_finished: '{{provider}}-formulier niet voltooid',
      hosted_not_finished_generic: 'Formulier van provider niet voltooid',
      waiting_for_provider: 'Wachten op provider',
      action_needed: 'Actie vereist',
      payments_live: 'Betalingen actief',
      online_payments_off: 'Online betalingen uit',
      waiting_for_partner: 'Wachten op u',
    },
    link_expired: 'Link verlopen',
    actions: {
      set_up: 'Instellen',
      change: 'Wijzigen',
      unlink: 'Ontkoppelen',
      remind: 'Eigenaar herinneren',
      reminded: 'Herinnerd · opnieuw {{time}}',
      start_over: 'Stripe-instelling opnieuw starten',
    },
    assign: {
      title: 'Welke provider moet {{name}} gebruiken?',
      label: 'Provider',
      confirm: 'Opslaan',
      cancel: 'Annuleren',
      primary: 'Standaard',
      none: 'Verbind eerst een provider.',
    },
    unlink: {
      title: '{{name}} ontkoppelen van {{provider}}?',
      title_generic: '{{name}} van de provider ontkoppelen?',
      description:
        'Het restaurant gaat terug naar Niet ingesteld, zodat je de juiste provider ervoor kunt kiezen. De provider blijft gekoppeld voor je andere restaurants.',
      confirm: 'Ontkoppelen',
    },
    pause: {
      title: 'Online betalingen worden gepauzeerd voor {{name}}',
      description:
        'Klanten kunnen niet meer online betalen totdat het restaurant opnieuw is ingesteld en geverifieerd bij een provider.',
      refunds:
        'Bestellingen die al via de huidige provider zijn betaald, kunnen niet meer vanuit FoodAmigos worden terugbetaald.',
      confirm: 'Onlinebetalingen voor dit restaurant pauzeren',
    },
    start_over: {
      title: 'De Stripe-instelling van {{name}} opnieuw starten?',
      points: {
        not_used: 'Het huidige Stripe-account ({{account}}) wordt niet meer gebruikt voor dit restaurant.',
        kept: 'Het account wordt niet verwijderd: het blijft in je Stripe staan, waar je het kunt weigeren.',
        fresh:
          'Bij de volgende keer “Doorgaan” begin je opnieuw op de eerste pagina van Stripe en kan een ander e-mailadres worden gebruikt.',
        paused:
          'Als het restaurant online betalingen ontvangt, worden die gepauzeerd totdat de nieuwe instelling is voltooid.',
      },
      confirm: 'Opnieuw starten',
      blocked: {
        received_payments:
          'Het Stripe-account van dit restaurant heeft betalingen ontvangen, dus de instelling kan niet opnieuw worden gestart. Neem contact op met de support om dit te wijzigen.',
        partner_action_needed: 'Los eerst het probleem op dat in je Stripe Connect wordt weergegeven.',
      },
    },
    toasts: {
      load_error: 'Uw restaurants laden is mislukt',
      assigned: 'Provider opgeslagen',
      assign_error: 'Provider opslaan is mislukt',
      unlinked: 'Restaurant ontkoppeld',
      unlink_error: 'Ontkoppelen van het restaurant mislukt',
      reminded: 'Herinnering naar de eigenaar verzonden',
      remind_error: 'Herinnering versturen is mislukt',
      cooling_down: 'De eigenaar is vandaag al herinnerd',
      started_over: 'Stripe-instelling opnieuw gestart',
      start_over_error: 'Stripe-instelling opnieuw starten mislukt',
    },
  },
  footer: {
    text: 'Uw FoodAmigos-servicekosten worden aan u gefactureerd, ongeacht welke provider een restaurant gebruikt.',
    link: 'Bekijk facturering',
  },
};
